module.exports = __webpack_public_path__ + "img/pan2.bb6d8ba5.jpg";